import { render } from "./RequestLogTable.vue?vue&type=template&id=167cc379"
import script from "./RequestLogTable.vue?vue&type=script&lang=js"
export * from "./RequestLogTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__